export const languageData = [
  {
    key: 'zh-CN',
    value: '简体中文',
  },
  {
    key: 'en',
    value: 'English',
  },
];
